import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { changeModal, LogOut } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { LogsRequest } from "./request.ts";
import { formatarDataParaYMDHMS, getDataformat } from "../../util/Months.js";
import i18n from "../../Config/i18n.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class LogServices {
    constructor() {
        this.requests = new LogsRequest();
        this.Permissions = [];
    }

    // Busca todos os logs
    async getAllLogs(search, page){
        try {
            const response = await this.requests.getAllLogs(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca todos os logs
    async getAllCommandsLogs(search, page, id_equipment){
        try {
            const response = await this.requests.getAllCommandsLogs(search, page, id_equipment);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    // Busca dados de um log
    async getLog(id){
        try {
            const response = await this.requests.getLog(id);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca todos os logs para download
    async getExcel(datainicio, datafim){
        store.dispatch(changeModal(''));
        try {
            toast(i18n.t('administrative.sub-items.logs.excel-download'), {
                position: "top-center",
                type: 'info',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            let data1 = formatarDataParaYMDHMS(datainicio);
            let data2 = formatarDataParaYMDHMS(datafim);
            const excel = await this.requests.getExcel(data1, data2);
            await this.createFile(excel.data, datainicio, datafim);
        } catch (error) {
            console.log(error)
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
        }
    }

    // Criar o arquivo para download
    async createFile (data, data1, data2){
        const url = window.URL.createObjectURL(data);
        let temp = getDataformat(data1) + ' até ' + getDataformat(data2);
      
        const link = document.createElement('a');
        link.href = url;
        link.download =  `${'Registros de '+temp}.xlsx`;
        link.click();
      
        // Liberar o URL do Blob após o download
        window.URL.revokeObjectURL(url);
    }

    async getAllEquipmentsLogs(id_equipment, level, start_date, end_date, page){
        try {
            const response = await this.requests.getAllEquipmentsLogs(id_equipment, level, start_date, end_date, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    async getEquipmentLog(id){
        try {
            const response = await this.requests.getEquipmentLog(id);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    async getAllEquipments(){
        try {
            const response = await this.requests.getAllEquipments();
            return response.authorized_equipments;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return [];
        }
    }

    async getAllCities(){
        try {
            const response = await this.requests.getAllCities();
            return response.authorized_cities;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }   
            return [];
        }
    }
}